import { FormAccountPickerPrintEditor } from './FormAccountPickerPrintEditor'

export const FormAccountPickerPrint = (props) => {
  return <FormAccountPickerPrintEditor {...props} />
}
